import { persistor, store } from './app/store'
import './index.scss';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { LoadingProvider } from './app/context/LoadingContext'
import { SimpleMusicPlayerProvider } from './app/context/SimpleMusicPlayerContext'
import { Suspense, lazy } from 'react'
import { ErrorBoundary } from './app/components/organisms/ErrorBoundary'
import { DisclaimerGate } from './app/components/organisms/DisclaimerGate'
import { LoadingScreen } from './app/components/molecules/LoadingScreen'
import * as Sentry from '@sentry/react'
import { DevConsoleProvider } from '@/app/devtools/runtime'
import { AutomationRuntime } from '@/app/automation/runtime'
import { DemoModeProvider } from '@/demo/runtime'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
const isSentryEnabled = import.meta.env.PROD
  && import.meta.env.VITE_SENTRY_ENABLED !== 'false'
  && Boolean(sentryDsn)

if (isSentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
      }),
      Sentry.consoleLoggingIntegration({ levels: ['error'] }),
    ],
  })
}


// Lazy load heavy components
const LoadingControllerLazy = lazy(() =>
  import('./app/components/organisms/LoadingController').then(module => ({ default: module.LoadingController }))
)

const shouldBypassDisclaimer = __INCLUDE_DEMO__

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LoadingProvider>
            <DisclaimerGate skipGate={shouldBypassDisclaimer}>
              <DevConsoleProvider>
                <AutomationRuntime />
                <DemoModeProvider>
                  <SimpleMusicPlayerProvider>
                    <Suspense fallback={<LoadingScreen />}>
                      <LoadingControllerLazy />
                    </Suspense>
                  </SimpleMusicPlayerProvider>
                </DemoModeProvider>
              </DevConsoleProvider>
            </DisclaimerGate>
          </LoadingProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
